import styled, { css } from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../../styles/hover';

// Styled Components — se reusan los compartidos de las tablas de gestión
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';

/**
 * Layout de las dos tablas: EN FILA (activas | inactivas), el mismo de
 * ExternalCompaniesManagementTable —que a su vez copia el de Usuarios—. En
 * pantallas estrechas se apilan solas.
 *
 * `TableContainer` NO se redefine aquí: se importa el compartido de
 * SummaryTablesStyles.
 */
export const ContainerTable = styled(Container)`
  display: flex;
  gap: 9.8rem;
  /**
   * 🔴 wrap SIEMPRE, no solo por debajo de un breakpoint.
   *
   * Estas filas son más anchas que las del resto de Gestión: la columna de
   * carretera lleva «C-25z (234+000 → 237+100)», que no se puede partir. La
   * tabla pide 645 px, y con las dos en fila el reparto le daba ~570 entre
   * 1163 y 1560 px de ventana — ahí la papelera quedaba cortada.
   *
   * Con wrap permanente y un min-width por tabla (abajo), se colocan en
   * fila SOLO cuando las dos caben de verdad, y si no se apilan solas. Así no
   * hay que acertar un breakpoint: lo decide el contenido.
   */
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    gap: 4rem;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 3.2rem;
  }
`;

export const ActivePresetsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  flex: 1;
  width: 57.2rem;
  max-width: 90.1rem;
  /* Lo que la tabla necesita para que quepan las dos líneas de carretera y los
     botones de acción (medido: 645 px). Por debajo de esto, el wrap del
     contenedor la baja a su propia fila en vez de recortarla. En pantallas muy
     anchas las dos vuelven a ponerse en fila solas. */
  min-width: 64rem;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    /* En tablet manda el ancho de la pantalla: sin esto, el min-width
       desbordaría por la derecha. La tabla se recorta con su scroll propio. */
    min-width: 0;
  }
`;

export const InactivePresetsTableContainer = styled(
  ActivePresetsTableContainer
)``;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

/**
 * Botón cuadrado garnet de 4rem: el mismo de SwapUserButton / ActionButton de
 * Equipos. Sirve tanto para las flechas de intercambio como para las acciones
 * de fila.
 */
const SquareGarnetButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
  cursor: pointer;

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover:not(:disabled) {
      opacity: 0.9;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: ${({ theme }) => theme.opacity.disabled};
  }
`;

/** ⮕ bajo la tabla de ACTIVAS: mueve la seleccionada a inactivas. */
export const SwapPresetButtonRight = styled(SquareGarnetButton)`
  align-self: end;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    align-self: flex-start;
  }
`;

/** ⬅ bajo la tabla de INACTIVAS: la devuelve a activas. */
export const SwapPresetButtonLeft = styled(SquareGarnetButton)``;

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const ActionButton = styled(SquareGarnetButton)`
  min-height: 3.2rem;
  min-width: 3.2rem;
  width: 3.2rem;
  font-size: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ActionIcon = styled.img`
  width: 1.6rem;
  height: 1.6rem;
`;
